dealershipModule.factory("DealerProfile", function() {
    var DealerProfile = function() {
        // the following are intended to be private, and should not be accessed directly.  Angular.js has a convention of using $$ prefix to indicate private members, however
        // doing so alters the semantics of the angular.equals function, in that it ignores $$ properties. This means that two ProfitSetting objects will be considered
        // equivalent if they are both of the same type, which is not what we want.
        this._id = null;
        this._ratingVersionId = '';
        this._overRemitAmount = 0;
        this._createdDate = null; //Date
    };

    DealerProfile.prototype.convertForBusinessSvcs = function() {
        var convertedDealerProfile = new SPANDealerProfile();

        convertedDealerProfile.mapDealerProfileFields(this);
        return convertedDealerProfile;
    };

    DealerProfile.prototype.populateDataFromBusinessSvcs = function(data) {
        this._id = data.ID;
        this._ratingVersionId = data.RatingVersionId;
        this.mapAmountFields(data);
        this.productData = data.Product;
    };

    DealerProfile.prototype.mapAmountFields= function(data) {
        this._overRemitAmount = data.OverRemit;
        var date = data.created_date;
        if (angular.isString(date)) {
            var mmddyyyy = date.split('/');
            var yyyy = mmddyyyy[2], mm = mmddyyyy[0], dd = mmddyyyy[1];
            date = new Date(yyyy, mm - 1, dd);
        };
        this._createdDate = date;
    };

    DealerProfile.prototype.toDisplayString = function()
    {
        return "$" + this._overRemitAmount;
    }

    // this is "private" class used for formatting the data correctly to set it in business services
    var SPANDealerProfile = function() {
        // currently, none of the following data is actually saved in the business services. If problems arise saving a dealer product profile,
        // check to make sure that hasn't changed in the UpdateDealerProfileProduct endpoint. The data is *required* to make
        // the WCF endpoint recognize the call, however.
        this.ID = null;
        this.ProfileStartDate = null;
        this.ProfileEndDate = null;
        this.ProductRateVersionId = null;
        this.Product = null;
        this.RatingVersionId = null;
        this.DealerInfoId = null;
        this.ProviderInfoId = null;
        this.ProductFee = 0;
        this.RatingFactor = 0;
        this.TermFactorsXml = null;
        // only these property values will be saved:
        this.OverRemit = null;
    };


    SPANDealerProfile.prototype.mapDealerProfileFields = function(dealerProfile) {
        this.ID = dealerProfile._id;
        this.OverRemit = Number(dealerProfile._overRemitAmount);
        this.RatingVersionId = Number(dealerProfile._ratingVersionId);
        this.Product = dealerProfile.productData;
    };

    return DealerProfile;
});
